import { connectionTypeFromDto } from '@features/insuranceCarriers/mappers/connectionTypeMapper';

const branchFromDto = (dto) => {
  if (!dto) return null;

  return {
    id: dto.id,
    name: dto.name,
  };
};

// Convierte undefined a null para incluir estos campos en el payload; de lo contrario, se omiten y el backend conserva el valor anterior
const credentialsToDto = (credentials = {}) => (
  Object.fromEntries(
    Object.entries(credentials).map(([key, value]) => [key, value === undefined ? null : value]),
  )
);

export const insuranceCarrierConfigurationFromDto = (dto) => ({
  id: dto.id,
  connectionType: connectionTypeFromDto(dto.connection_type),
  sede: branchFromDto(dto.sede),
  credentials: dto.authentication,
  enabled: dto.enabled,
  createdAt: dto.created_at,
  updatedAt: dto.updated_at,
});

export const insuranceCarrierConfigurationCreateToDto = (data) => ({
  connection_type_code: data.connectionTypeCode,
  sede: data.branchId,
  authentication: credentialsToDto(data.credentials),
  enabled: data.enabled,
});

export const insuranceCarrierConfigurationUpdateToDto = (data) => ({
  authentication: data.credentials ? credentialsToDto(data.credentials) : undefined,
  enabled: data.enabled,
});
